<!-- Documentation: https://studiumtech.atlassian.net/wiki/spaces/LMS1/pages/195035166/Button -->

<template>
  <v-btn
    :color="color"
    :disabled="disabled"
    :loading="loading"
    :outlined="outlined"
    :depressed="depressed"
    :block="block"
    :text="text"
    :elevation="elevation"
    :small="small"
    @click="handleClick"
    :style="buttonStyle"
    :class="buttonClasses"
  >
    <v-icon v-if="icon" :style="{ color: textColor, fontSize: iconFontSize }">{{
      icon
    }}</v-icon>
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: "PrimaryButton",
  props: {
    icon: {
      type: String,
      default: "",
    },
    iconFontSize: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "normal",
      validator: (value) =>
        [
          "xxx-small",
          "xx-small",
          "x-small",
          "small",
          "normal",
          "large",
          "x-large",
          "xx-large",
        ].includes(value),
    },
    textColor: {
      type: String,
      default: "",
    },
    textFontSize: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    depressed: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: String,
      default: "0",
    },
    squared: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonStyle() {
      const sizeInPixels = this.getDefaultButtonHeight();
      let sizeObj = {
        color: this.textColor,
        fontSize: this.textFontSize
      }
      if (this.squared) {
        sizeObj['height'] = sizeInPixels
        sizeObj['lineHeight'] = sizeInPixels
        sizeObj['width'] = sizeInPixels
        sizeObj['minHeight'] = sizeInPixels
        sizeObj['minWidth'] = sizeInPixels
        sizeObj['padding'] = 0
      }
      return sizeObj;
    },
    buttonClasses() {
      return {
        [`v-btn--${this.size}`]: true,
      };
    },
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
    getDefaultButtonHeight() {
      // Define default heights for Vuetify button sizes
      const sizeMap = {
        "xxx-small": "24px",
        "xx-small": "28px",
        "x-small": "32px",
        "small": "36px",
        "normal": "40px",
        "large": "44px",
        "x-large": "48px",
        "xx-large": "52px",
      };
      return sizeMap[this.size] || sizeMap["normal"];
    },
  },
};
</script>

<style scoped>
/* Add any styles you need here */
</style>
